import { Customer } from '../models/customer';
import { Job } from '../models/job';
import { JobStatusEnum } from '../models/jobStatusEnum';
import { JobCounts } from './getJobCounts';

export enum DispoJobStatus {
  CANCELED = 'CANCELED',
  AVAILABLE = 'AVAILABLE',
  BOOKED = 'BOOKED',
  OPEN = 'OPEN',
  ACTION_REQUIRED = 'ACTION_REQUIRED',
}

export function getJobStatusForDispo(
  job: Job,
  counts: JobCounts,
  loggedInCustomer: Customer,
): DispoJobStatus {
  if (job.status === JobStatusEnum.CANCELED) {
    return DispoJobStatus.CANCELED;
  }
  if (
    counts.available > 0 &&
    (counts.booked || 0) < (job?.requiredUsers || 1)
  ) {
    return DispoJobStatus.AVAILABLE;
  } else if (counts.booked > 0) {
    return DispoJobStatus.BOOKED;
  } else if (
    counts.open > 0 ||
    (loggedInCustomer?.transferredJobsNoLongerActionRequired &&
      job.transfers?.some((t) => t.transferredAt))
  ) {
    return DispoJobStatus.OPEN;
  } else {
    return DispoJobStatus.ACTION_REQUIRED;
  }
}

export function getJobStatusArrayForDispo(
  job: Job,
  counts: JobCounts,
  loggedInCustomer: Customer,
): DispoJobStatus[] {
  if (job.status === JobStatusEnum.CANCELED) {
    return [DispoJobStatus.CANCELED];
  }
  let statuses: DispoJobStatus[] = [];
  for (let i = 0; i < job.requiredUsers; i++) {
    if (counts.booked > i) {
      statuses.push(DispoJobStatus.BOOKED);
    } else if (counts.available > i) {
      statuses.push(DispoJobStatus.AVAILABLE);
    } else if (
      counts.open > i ||
      (loggedInCustomer?.transferredJobsNoLongerActionRequired &&
        job.transfers?.some((t) => t.transferredAt))
    ) {
      statuses.push(DispoJobStatus.OPEN);
    } else {
      statuses.push(DispoJobStatus.ACTION_REQUIRED);
    }
  }
  return statuses;
}
